import {
    allFetch
} from "../Domain";

/**
 * @description 使用者自訂表單
 */
export const PermissionFunction = (() => {
    /**
     * @description 查詢權限功能
     */
    const PermissionFunctionSearch = async function (obj) {
        return await allFetch('PermissionFunction/PermissionFunctionSearch', obj);
    }
    /**
     * @description 權限功能新建
     */
    const PermissionFunctionCreate = async function (obj = {
        name: '',
        api_name: '',
        join_limit: ''
    }) {
        return await allFetch('PermissionFunction/PermissionFunctionCreate', obj);
    }
    /**
     * @description 查詢權限功能
     */
    const PermissionFunctionDetail = async function (obj) {
        return await allFetch('PermissionFunction/PermissionFunctionDetail', obj);
    }
    /**
     * @description 權限功能修改
     */
    const PermissionFunctionUpdate = async function (obj) {
        return await allFetch('PermissionFunction/PermissionFunctionUpdate', obj);
    }
    /**
     * @description 權限功能綁定職責
     */
    const PermissionFunctionUpdateUserDuty = async function (obj) {
        return await allFetch('PermissionFunction/PermissionFunctionUpdateUserDuty', obj);
    }
    /**
     * @description 系統功能綁定關係
     */
    const PermissionCheckValid = async function (obj) {
        return await allFetch('PermissionFunction/PermissionCheckValid', obj);
    }
    return {
        PermissionFunctionSearch,
        PermissionFunctionCreate,
        PermissionFunctionDetail,
        PermissionFunctionUpdate,
        PermissionFunctionUpdateUserDuty,
        PermissionCheckValid
    }
})();